import * as React from 'react';
import { FormatDate } from '../../Components/WorldNet/DateFormatting';
import { GenerateId } from './IdGeneration';
import { SupportedCards } from './WorldNetConfig';

interface Props {
    mpiUrl: string;
    evoApiUrl: string;
    terminalId: string;
    email: string;

    amountInPence: number;
    currency: string;

    cardDetails: {
        type: SupportedCards;
        number: string;
        holderName: string;
        expiryDate: string;
        cvv: string;
    };

    worldNet3DSecureCallback(result: string, mpiRef: string, orderId: string): void;
}

interface State {
    formattedDateTime: string;
    hash: string | null;
    orderId: string;
}

export default class WorldNet3DSecure extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            hash: null,
            formattedDateTime: FormatDate(new Date()),
            orderId: GenerateId(),
        };
    }

    componentDidMount() {
        fetch(this.props.evoApiUrl + '/api/donations/worldnet/3dsecure/hash', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                orderId: this.state.orderId,
                number: this.props.cardDetails.number,
                expiry: this.props.cardDetails.expiryDate,
                type: this.props.cardDetails.type,
                amount: this.props.amountInPence / 100,
                dateTime: this.state.formattedDateTime,
            })
        }).then(response => {
            return response.text();
        }).then(hash => {
            this.setState({ hash: hash });
        });

        window.addEventListener('message', this.iframeCallback, false);
    }

    iframeCallback = (event: MessageEvent) => {
        if (event.origin === this.props.evoApiUrl) {
            this.props.worldNet3DSecureCallback(event.data.result, event.data.mpiRef, event.data.orderId);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.iframeCallback);
    }

    render() {

        if (this.state.hash === null) {
            return null;
        }

        let formHtml = "<body onload='document.frm.submit()'>";
        formHtml += `<form action='${this.props.mpiUrl}' name='frm'>`;
        formHtml += `<input type='hidden' name='TERMINALID' value='${this.props.terminalId}' />`;
        formHtml += `<input type='hidden' name='ORDERID' value='${this.state.orderId}' />`;
        formHtml += `<input type='hidden' name='CURRENCY' value='${this.props.currency}' />`;
        formHtml += `<input type='hidden' name='AMOUNT' value='${this.props.amountInPence / 100}' />`;
        formHtml += `<input type='hidden' name='DATETIME' value='${this.state.formattedDateTime}' />`;
        formHtml += `<input type='hidden' name='CARDHOLDERNAME' value='${this.props.cardDetails.holderName}' />`;
        formHtml += `<input type='hidden' name='EMAIL' value='${this.props.email}' />`;
        formHtml += `<input type='hidden' name='CARDNUMBER' value='${this.props.cardDetails.number}' />`;
        formHtml += `<input type='hidden' name='CARDEXPIRY' value='${this.props.cardDetails.expiryDate}' />`;
        formHtml += `<input type='hidden' name='CARDTYPE' value='${this.props.cardDetails.type}' />`;
        formHtml += `<input type='hidden' name='HASH' value='${this.state.hash}' />`;
        formHtml += `<input type='hidden' name='CVV' value='${this.props.cardDetails.cvv}' />`;
        formHtml += `<input type='hidden' name='CARDHOLDER_CHALLENGE' value='REQUIRED' />`;
        formHtml += '</form>';
        formHtml += '</body>';

        return <iframe srcDoc={formHtml} height="600px" width="100%"  />;
    }
}


// WEBPACK FOOTER //
// ./src/Components/WorldNet/WorldNet3DSecure.tsx